<script lang="ts" setup>
import { useAnchor } from '~/composables/anchor'
import type { TocItem } from '~/types/toc-item'

defineProps<{
  items: TocItem[]
}>()

useAnchor()
</script>

<template>
  <div v-if="items.length > 0" class="toc">
    <div class="toc__title">
      Содержание статьи
    </div>
    <div class="toc__list flex flex-col items-start">
      <a v-for="(x, i) in items" :key="i" class="toc__link" :href="x.href">
        <span>{{ x.title }}</span>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.toc {
  border-bottom: 1px dashed variables.$main-light-gray-color;
  padding-bottom: 2rem;

  &__link {
    color: variables.$main-gray-color;
    text-decoration: unset;

    &:before {
      content: '\276F';
      padding-right: 1rem;
    }

    &:hover span {
      border-color: transparent;
    }

    span {
      border-bottom: 1px dashed variables.$main-gray-color;
    }
  }

  &__list {
    gap: .7rem;
    margin-left: .5rem;
  }

  &__title {
    padding-bottom: .9rem;
    font-weight: 700;
  }
}
</style>
